var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.placeBidModal",modifiers:{"placeBidModal":true}}],staticClass:"btn btn-primary btn-bid-buy"},[_vm._v(" "+_vm._s(_vm.$t('Bid / Buy'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }